export default __webpack_public_path__ + "static/media/gym.fbd01510.png";